import { useContext } from 'react'
import { FocusModeContext } from './FocusModeContext'

export const useFocusMode = () => {
  const ctx = useContext(FocusModeContext)
  if (!ctx) throw new Error('useFocusMode must be used inside <FocusModeProvider>')
  return ctx
}
